import { useSyncExternalStore } from "react";
import { usePlatformCapabilities } from "@shared-core/capabilities/context";

/**
 * How much of the screen's bottom an on-screen keyboard covers now, in CSS
 * pixels, and again whenever it changes. 0 with no keyboard, and where the
 * platform cannot tell (the footer then stays where the page puts it).
 */
export function useKeyboardInset(): number {
  const capabilities = usePlatformCapabilities();
  return useSyncExternalStore(
    (onChange) => capabilities.onKeyboardInsetChange(onChange),
    () => capabilities.getKeyboardInset(),
  );
}
